import {DriveItem} from "./drive-item";

export class Directory extends DriveItem {
    nodeVar: string;
    parent: Directory;
    children: Directory[];

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes || {};

        this.name = attributes['title'];
        this.createBy = attributes['user_contact'];
        this.creationTimestamp = attributes['creation_timestamp']
        this.nodeVar = attributes['entity_var'];
        this.type = 'directory';
    }
}
